import React,{ Component } from 'react';

import {
  Row,
  Col,
  Button,
  FormText,
  Input,
  Label,
  FormGroup
} from 'reactstrap';

import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import TextInput from '../../../shared/components/TextInput';
import HiddenInput from '../../../shared/components/HiddenInput';
import Form from '../../../shared/components/Form';
import ProgressEllipses from '../../../shared/components/ProgressEllipses';
import TutorialPopover from '../../../shared/components/TutorialPopover';
import DCMTagInput from '../../../shared/components/DCMTagInput';

import { validateQAEngagement } from '../../../shared/validators';

import TrashSVG from '../../../shared/assets/trash.svg';

const OPTION_PLACEHOLDERS = ['Apple','Orange','Grapefruit','Tangerine'];


class CampaignQAForm extends Component {
  constructor(){
    super();

    this.state = {
      validationMessages:{},
      isAddingChoice:false,
      firstImage:null,
      secondImage:null,
      isShowingPopover:false,
      useFirstImageForSecondImage:false
    };
  }

  componentDidMount(){
    if(this.props.activeEngagementFirstImageURL && this.props.activeEngagementFirstImageFileName){
      this.setState({firstImage:{
        id:this.props.activeEngagementFirstImageId,
        fileName:this.props.activeEngagementFirstImageFileName,
        large:this.props.activeEngagementFirstImageURL
      }});
    }

    if(this.props.activeEngagementSecondImageURL && this.props.activeEngagementSecondImageFileName){
      this.setState({secondImage:{
        id:this.props.activeEngagementSecondImageId,
        fileName:this.props.activeEngagementSecondImageFileName,
        large:this.props.activeEngagementSecondImageURL
      }});
    }

    if(this.props.activeEngagementFirstImageURL && this.props.activeEngagementFirstImageURL == this.props.activeEngagementSecondImageURL){
      this.setState({useFirstImageForSecondImage:true});
    }
  }

  componentWillReceiveProps(nextProps){
    if(!this.props.open && nextProps.open){
      window.setTimeout(() => this.setState({isShowingPopover:true}),500);
    }

    if(this.props.open && !nextProps.open){
      this.setState({isShowingPopover:false});
    }
  }

  handleAddChoiceClick(event){
    event.preventDefault();
    this.setState({isAddingChoice:true})
    this.props.onAddChoiceClick()
      .then(() => this.setState({isAddingChoice:false}))
      .catch((err) => this.setState({error:err}));
  }

  handleDeleteOptionClick(event,id){
    event.preventDefault();
    this.props.onDeleteChoiceClick(id);
  }

  handleSubmit(data){
    const { firstImage, secondImage, useFirstImageForSecondImage } = this.state;

    data.tags = (data.firstTags || []).concat(data.secondTags || []);

    if(!data.options) data.options = [];

    if (firstImage) {
      data.firstImageId = firstImage.id
      data.firstImageURL = firstImage.large;
      data.firstImageFileName = firstImage.fileName;
      if (useFirstImageForSecondImage) {
        data.secondImageURL = firstImage.large;
        data.secondImageFileName = firstImage.fileName;
        data.secondImageId = firstImage.id;
      } else {
        if (secondImage) {
          data.secondImageURL = secondImage.large;
          data.secondImageFileName = secondImage.fileName;
          data.secondImageId = secondImage.id;
        }
      }
    }

    const validationMessages = validateQAEngagement(data);

    delete data.firstTags;
    delete data.secondTags;

    if(Object.keys(validationMessages).length > 0){
      this.setState({validationMessages:validationMessages});
      this.props.onSubmit(data);
    } else {
      this.setState({validationMessages:{}});
      this.props.onSubmit(data);
    }
  }

  render(){
    return (
      <Form 
        includeEmpty
        onSubmit={(data) => this.handleSubmit(data)}
      >
        <TutorialPopover
          open={this.state.isShowingPopover && this.props.isShowingTutorial}
          target={`QATextInput_${this.props.activeEngagementId}`}
          onCloseClick={() => this.setState({isShowingPopover:false})}
          title='Trivia Activity'
        >
          <p>
            Ask a question and consumers answer by picking from up to four answers.<br />
            They then learn the correct answer along with details.
            <br /><br />
            Suggestions:<br />
            Have fun<br />
            Educate consumers
          </p>
        </TutorialPopover>
        <HiddenInput name='id' value={this.props.activeEngagementId} />
        <TextInput
          id={`QATextInput_${this.props.activeEngagementId}`}
          label='Question'
          name='text'
          multiline
          defaultValue={this.props.activeEngagementText}
          placeholder='Which fruit has the most Vitamin C?'
          warning={this.state.validationMessages['text']}
          maxLength={100}
          showLengthIndicatorAtLength={15}
        />
        {this.props.activeEngagementOptions.map((o,index) => (
          <Row key={o.id}>
            <Col xs='9'>
              <HiddenInput
                name={`options[${index}][id]`}
                value={o.id}
              />
              <TextInput
                label={`Answer ${index + 1}`}
                name={`options[${index}][answer]`}
                defaultValue={o.answer}
                placeholder={OPTION_PLACEHOLDERS[index]}
                warning={this.state.validationMessages['options'] ? this.state.validationMessages['options'][index] : ''}
                maxLength={70}
              />
            </Col>
            <Col xs='2'>
              <Label check className='QACorrectLabel'>
                <Input
                  type='radio'
                  name='correctAnswerId'
                  value={o.id}
                  defaultChecked={o.id === this.props.activeEngagementCorrectAnswerId}
                />
                &nbsp;&nbsp;Correct
              </Label>
            </Col>
            <Col xs='1'>
              <br />
              <img
                src={TrashSVG}
                className='OptionTrashIcon'
                onClick={(e) => this.handleDeleteOptionClick(e,o.id)}
                alt='Trash'
              />
            </Col>
          </Row>
        ))}
        {this.props.activeEngagementOptions.length < 4 && (
          <div>
            <Button
              size='sm'
              onClick={(e) => this.handleAddChoiceClick(e)}
              disabled={this.state.isAddingChoice}
            >
              &nbsp;&nbsp;
              {this.state.isAddingChoice ?(<span>Adding Choice<ProgressEllipses /></span> ) :'Add Choice'}
              &nbsp;&nbsp;
            </Button>
            {this.state.validationMessages['engagementCount'] && (
              <FormText className='DangerFeedback'>
                {this.state.validationMessages['engagementCount']}
              </FormText>
            )}
          </div>
        )}
        {this.state.validationMessages['correctAnswerId'] && (
          <div>
            <FormText className='DangerFeedback'>
              {this.state.validationMessages['correctAnswerId']}
            </FormText>
          </div>
        )}
        <br />
        <DroppableFileInput
          label='Question image'
          text='Upload image'
          name='firstImage'
          fileType='image'
          cropperAspectRatio={4/3}
          onChange={(image) => this.setState({firstImage:image})}
          warning={this.state.validationMessages['firstImageURL']}
          existingFileName={this.props.activeEngagementFirstImageFileName}
          existingFileURL={this.props.activeEngagementFirstImageURL}
          tooltip={(
            <span>Use a large crisp 4x3 image.<br />We recommend 800px by 600px.  <br />Maximum file size of 2MB.</span>
          )}
        />
        <DCMTagInput
          type='first'
          name='firstTags'
          defaultValue={this.props.activeEngagementFirstTags}
          warning={this.state.validationMessages['firstTags']}
        />
        <hr />
        <TextInput
          id={`QATextInput_${this.props.activeEngagementId}`}
          label='Correct answer details'
          name='correctAnswerText'
          multiline
          defaultValue={this.props.activeEngagementCorrectAnswerText}
          placeholder='Vitamin C protects against heart disease, aids in absorption of iron, and decreases bad cholesterol and triglycerides. It may also lessen symptoms of a common cold & support healthy immune function.'
          warning={this.state.validationMessages['correctAnswerText']}
          maxLength={200}
        />
        <br />
        <DroppableFileInput
          label='Correct answer image'
          disabled={this.state.useFirstImageForSecondImage}
          text='Upload image'
          name='secondImage'
          fileType='image'
          cropperAspectRatio={4/3}
          onChange={(image) => this.setState({secondImage:image})}
          warning={this.state.validationMessages['secondImageURL']}
          existingFileName={this.props.activeEngagementSecondImageFileName}
          existingFileURL={this.props.activeEngagementSecondImageURL}
          tooltip={(
            <span>Use a large crisp 4x3 image.<br />We recommend 800px by 600px.  <br />Maximum file size of 2MB.</span>
          )}
          additionalOptions={(
            <FormGroup check>
              <Label check>
                <Input
                  type='checkbox'
                  checked={this.state.useFirstImageForSecondImage}
                  onClick={(e) => this.setState({useFirstImageForSecondImage:e.target.checked})}
                />
                &nbsp;&nbsp;Use question image
              </Label>
            </FormGroup>
          )}
        />
        <DCMTagInput
          type='second'
          name='secondTags'
          defaultValue={this.props.activeEngagementSecondTags}
          warning={this.state.validationMessages['secondTags']}
        />
        <br />
        <Button size='sm' color='primary' type='submit'>
          &nbsp;&nbsp;Save&nbsp;&nbsp;
        </Button>
      </Form>
    )
  }
}
CampaignQAForm.defaultProps = {
  onDeleteChoiceClick:() => {},
  onAddChoiceClick:() => {},
  isShowingTutorial:true,
  showSuperadminFeatures:false
};

export default CampaignQAForm;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CampaignQAForm.js